module.exports = __webpack_public_path__ + "static/img/background.95733591.svg";